import React, { useState, useRef, useEffect } from 'react';
import "./RegistrationForm.css";

const RegistrationForm = () => {
  const [inquiryPurpose, setInquiryPurpose] = useState("");
  const [description, setDescription] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [organization, setOrganization] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const [isPopupVisible, setPopupVisibility] = useState(false);
  const [popupVariant, setPopupVariant] = useState("");
  const [popupMessage, setPopupMessage] = useState("");

  // Ref to hold the timer ID
  const popupTimerRef = useRef(null);

  // Cleanup effect to clear the timer when the component unmounts
  useEffect(() => {
    return () => {
      clearTimeout(popupTimerRef.current);
    };
  }, []);

  // Function to close the popup and clear the timer
  const closePopup = () => {
    clearTimeout(popupTimerRef.current); // Clear timer
    setPopupVisibility(false);
  };

  // Function to display the popup message and start the 5-second timer
  const displayPopup = (variant, msg) => {
    clearTimeout(popupTimerRef.current); // Clear any existing timer first
    setPopupVariant(variant);
    setPopupMessage(msg);
    setPopupVisibility(true);
    // Set a new timer to close the popup automatically after 5 seconds
    popupTimerRef.current = setTimeout(() => {
      closePopup();
    }, 5000);
  };

  const handleFormSubmission = async (e) => {
    e.preventDefault();

    if (!inquiryPurpose) {
      displayPopup("error", "Please select an inquiry purpose");
      return;
    }
    if (!description) {
      displayPopup("error", "Please select a description");
      return;
    }
    if (!fullName.trim()) {
      displayPopup("error", "Please enter your full name");
      return;
    }
    if (!email.includes("@")) {
      displayPopup("error", "Please enter a valid email address");
      return;
    }
    if (!message.trim()) {
      displayPopup("error", "Please enter your message");
      return;
    }

    const submissionData = {
      inquiryPurpose, description, fullName, email, organization, phone, message,
    };

    try {
      const response = await fetch('https://n8n.indraq.info/webhook/97be73cb-f93a-46a6-84bb-96cd38fa43bb', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(submissionData),
      });

      if (response.ok) {
        displayPopup("success", "Submitted! We'll get back to you within 24 hours.");
        setInquiryPurpose("");
        setDescription("");
        setFullName("");
        setEmail("");
        setOrganization("");
        setPhone("");
        setMessage("");
      } else {
        displayPopup("error", "Something went wrong. Please try again later.");
      }
    } catch (error) {
      console.error('Submission Error:', error);
      displayPopup("error", "Failed to submit. Please check your network connection.");
    }
  };

  return (
    <div className="enquiry-form__page-wrapper">
      <div className="enquiry-form__container-main">
        <div className="enquiry-form__content-section">
          <div className="enquiry-form__header">
            <h1 className="enquiry-form__title">Or fill out the form below</h1>
            <p className="enquiry-form__subtitle">We'll get back to you within 24 hours.</p>
          </div>
          <form onSubmit={handleFormSubmission} noValidate>
            {/* Form fields... */}
            <div className="enquiry-form__field-row">
              <div className="enquiry-form__input-group">
                <label htmlFor="inquiry-purpose" className="enquiry-form__label">Inquiry Purpose <span className="enquiry-form__required-indicator">*</span></label>
                <select id="inquiry-purpose" className="enquiry-form__select-input" value={inquiryPurpose} onChange={e => setInquiryPurpose(e.target.value)} required>
                  <option value="" disabled>Choose one option...</option>
                  <option value="general">General Inquiry</option>
                  <option value="support">Technical Support</option>
                  <option value="sales">Refund Inquiry</option>
                  <option value="partnership">Partnership</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="enquiry-form__input-group">
                <label htmlFor="description" className="enquiry-form__label">Description that fits you <span className="enquiry-form__required-indicator">*</span></label>
                <select id="description" className="enquiry-form__select-input" value={description} onChange={e => setDescription(e.target.value)} required>
                  <option value="" disabled>Choose one option...</option>
                  <option value="parent">Parent</option>
                  <option value="enterprise">Enterprise</option>
                  <option value="student">Student</option>
                </select>
              </div>
            </div>

            <div className="enquiry-form__field-row">
                <div className="enquiry-form__input-group">
                    <label htmlFor="full-name" className="enquiry-form__label">Full Name <span className="enquiry-form__required-indicator">*</span></label>
                    <input type="text" id="full-name" className="enquiry-form__text-input" placeholder="Enter your full name..." value={fullName} onChange={e => setFullName(e.target.value)} required />
                </div>
                <div className="enquiry-form__input-group">
                    <label htmlFor="email" className="enquiry-form__label">Email Address <span className="enquiry-form__required-indicator">*</span></label>
                    <input type="email" id="email" className="enquiry-form__text-input" placeholder="Enter your email address..." value={email} onChange={e => setEmail(e.target.value)} required />
                </div>
            </div>

            <div className="enquiry-form__field-row">
                <div className="enquiry-form__input-group">
                    <label htmlFor="organization" className="enquiry-form__label">Organization</label>
                    <input type="text" id="organization" className="enquiry-form__text-input" placeholder="Enter your organization..." value={organization} onChange={e => setOrganization(e.target.value)} />
                </div>
                <div className="enquiry-form__input-group">
                    <label htmlFor="phone" className="enquiry-form__label">Phone Number</label>
                    <input type="tel" id="phone" className="enquiry-form__text-input" placeholder="Enter your phone number..." value={phone} onChange={e => setPhone(e.target.value)} />
                </div>
            </div>

            <div className="enquiry-form__input-group enquiry-form__input-group--full-width">
                <label htmlFor="message" className="enquiry-form__label">Message <span className="enquiry-form__required-indicator">*</span></label>
                <textarea id="message" className="enquiry-form__textarea-input" placeholder="Enter your message here..." value={message} onChange={e => setMessage(e.target.value)} required />
            </div>

            <button type="submit" className="enquiry-form__submit-button">
              Submit Form
              <img src="/photos/plant.jpg" alt="Submit Icon" className="enquiry-form__submit-icon" />
            </button>
          </form>
        </div>
        <div className="enquiry-form__visual-section"></div>
      </div>

      {isPopupVisible && (
        <div className="enquiry-form__popup-backdrop" onClick={closePopup}>
          <div className={`enquiry-form__popup-dialog enquiry-form__popup-dialog--${popupVariant}`} onClick={(e) => e.stopPropagation()}>
            <button className="enquiry-form__popup-close-btn" onClick={closePopup}>×</button>
            <div className="enquiry-form__popup-body">
              {popupVariant === "error" ? (
                <>
                  <div className="enquiry-form__popup-graphic enquiry-form__popup-graphic--error">✕</div>
                  <h4 className="enquiry-form__popup-heading">Oops!</h4>
                  <p className="enquiry-form__popup-text">{popupMessage}</p>
                </>
              ) : (
                <>
                  <div className="enquiry-form__popup-graphic enquiry-form__popup-graphic--success">✓</div>
                  <h4 className="enquiry-form__popup-heading">Submitted!</h4>
                  <p className="enquiry-form__popup-text">{popupMessage}</p>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegistrationForm;